import React from 'react';
import Modal from 'components/Modal';

const AboutProModal = ({ isOpen, toggle, proDescription }) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    title="SOBRE O PROFISSIONAL"
    width="800px"
  >
    <p>{proDescription}</p>
  </Modal>
);

export default AboutProModal;
